import dayjs from "dayjs"
import { checkTargetGroupsValidity } from "@/helpers"
const validationRules = component => {
    component.formErrors = []
    let adsQuery = component.$store.getters.getAdsQuery
    let startDate = adsQuery.startDate
    let endDate = adsQuery.endDate
    let storedTargets = adsQuery.target_group
    let daysBetweenDates = dayjs(endDate).diff(startDate, "day") + 1
    let yearsBetweenDates = dayjs(endDate)
        .subtract(1, "d")
        .diff(startDate, "y")
    if (yearsBetweenDates >= 1) {
        component.formErrors.push("Maximum period is 1 year.")
    }
    if (daysBetweenDates > 1) {
        if (adsQuery.filmCode.length === 0 && !adsQuery.buyingAgencies && !adsQuery.advertisers && !adsQuery.products && (adsQuery.providerKeys.length == 0 || adsQuery.providerKeys.length > 10))
            component.formErrors.push("Please specify at least 1 film code, 1 agency, 1 advertiser, 1 product or 1-10 channels.")
        let maxTargetGroupCount = 6
        if (Number.isInteger(component.config_NumberOfTargetGroupsAd)) maxTargetGroupCount = component.config_NumberOfTargetGroupsAd
        else maxTargetGroupCount = 6
        if (storedTargets.length > maxTargetGroupCount) {
            component.formErrors.push(`Maximum ${maxTargetGroupCount} measures can be used.`)
        }
    }
    let monthsBetweenDates = dayjs(endDate).diff(startDate, "M", true)
    if (monthsBetweenDates > 6 && storedTargets.length > 1) {
        component.formErrors.push("The period is greater than 6 months and then maximum 1 measure can be used.")
    } else if (monthsBetweenDates > 3 && storedTargets.length > 2) {
        component.formErrors.push("The period is greater than 3 months and then maximum 2 measures can be used.")
    } else if (monthsBetweenDates > 1 && storedTargets.length > 4) {
        component.formErrors.push("The period is greater than 1 month and then maximum 4 measures can be used.")
    }
    if (component.formErrors.length > 0) component.formErrors.unshift("Your search risks returning a very large dataset.")

    let targetGroupErrors = checkTargetGroupsValidity(storedTargets, startDate)
    if (targetGroupErrors.length > 0) {
        for (let i = 0; i < targetGroupErrors.length; i++) {
            component.formErrors.push(targetGroupErrors[i])
        }
    }
}
export { validationRules }
